import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=30e54e96&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e54e96",
  null
  
)

export default component.exports